exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndl dt[data-v-90633614], dl dd[data-v-90633614] {\n  padding: 0.5rem 3rem;\n}\ndl dt .md-checkbox.md-theme-default.md-checked .md-ripple[data-v-90633614], dl dd .md-checkbox.md-theme-default.md-checked .md-ripple[data-v-90633614] {\n    color: #52ff52;\n    color: var(--md-theme-default-accent, #52ff52);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90633614","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/StartCheck.vue
// module id = zzuo
// module chunks = 1